export const environment = {
  unimagenBaseUrl: 'https://dev.api.unimagen.ovh/rum',
  keycloakUrl: 'https://dev.auth.unimagen.ovh/',
  realm: 'unimagen',
  clientId: 'unimagen'
};
